/* Bootstrap */

// import "bootstrap";
// import { Modal } from 'bootstrap'

/* Custom SCSS */
// import "./index.scss";
// import './style-login.scss';
// import './style-admin.scss';
// import './style-buttons.scss';

/* Swiper */

//import Swiper from "swiper";
import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import 'swiper/css/navigation';
//import 'swiper/css/pagination';
// import 'swiper/css/scrollbar';

// Swiper.use([Scrollbar]);
// init Swiper:

var certificazioni_slider = new Swiper(".certificazioni_slider", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2000,
    },
    autoHeight: false,
    slidesPerView: 'auto',
    spaceBetween: 24,
    modules: [Navigation, Autoplay],
});



// import swiperSlider from "./js/swiperSlider";
// swiperSlider();

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */



// var Isotope = require('isotope-layout');

import massimo from "./js/massimo";
massimo();

import swiperSlider from "./js/swiperSlider";
swiperSlider();

import navbar from "./js/navbar";
navbar();

// import footer from "./js/footer";
// footer();

// import sidebar from "./js/sidebar";
// sidebar();

// import search from "./js/search";
// search();

// import woocommerce from "./js/woocommerce";
// woocommerce();

import scrollTop from "./js/scrollTop";
scrollTop();
